module.exports = __webpack_public_path__ + "img/hr-tree-06-b-leaves.e3b0de8f.png";